import { createListStore } from "./list";
import { AnswerService } from "@/services/answers";

export const useAnswersStore = createListStore("answers", AnswerService);
